import { times } from 'utilities/helperFunctions';

require('./RAContributionPeriodicity.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const Select = require('react-select');
const classNames = require('classnames');
// @ commons
const { AmountInput } = require('commonsComponents/amountInput');
// @ utilities
import { FormattedText, formatText, getLanguage } from 'core/i18n';

// @ constants
const {
    CONTRIBUTION_PERIOD_DAILY,
    CONTRIBUTION_PERIOD_MONTHLY,
    CONTRIBUTION_PERIOD_PUNCTUAL,
    CONTRIBUTION_PERIOD_WEEKLY,
    EURO_SYMBOL,
    FULL_MONTH_DAYS,
    MAXIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
    MAXIMUM_PERIODIC_CONTRIBUTION,
} = require('constants/RAConstants');

class RAContributionPeriodicity extends React.Component {
    buildSelectedPeriodicityCopy() {
        let periodicityCopy = null;

        if (this.props.electedPeriodicity === CONTRIBUTION_PERIOD_DAILY) {
            periodicityCopy = (
                <div className="ra-contribution-periodicity__select-copy">
                    <FormattedText value="raContributionPeriodicity-periodicityCopy" />
                </div>
            );
        }

        return periodicityCopy;
    }

    buildPeriodicitySelect() {
        const { allowPunctual, disableSelect, onPeriodicityChange, selectedPeriodicity, disabled } = this.props;
        const periodicityCopy = this.buildSelectedPeriodicityCopy();
        const options = [
            {
                label: formatText('raContributionPeriodicity-daily'),
                value: CONTRIBUTION_PERIOD_DAILY,
            },
            {
                label: formatText('raContributionPeriodicity-weekly'),
                value: CONTRIBUTION_PERIOD_WEEKLY,
            },
            {
                label: formatText('raContributionPeriodicity-monthly'),
                value: CONTRIBUTION_PERIOD_MONTHLY,
            },
        ];

        if (allowPunctual) {
            options.push({
                label: formatText('raContributionPeriodicity-punctual'),
                value: CONTRIBUTION_PERIOD_PUNCTUAL,
            });
        }

        return (
            <div className="ra-contribution-periodicity__select">
                <label className="ra-contribution-periodicity__select-label">
                    <FormattedText value="raContributionPeriodicity-selectInfo" />
                </label>
                <Select.Creatable
                    className="form__select"
                    clearable={false}
                    closeTimeOutMS={150}
                    disabled={disableSelect || disabled}
                    onChange={onPeriodicityChange}
                    options={options}
                    searchable={false}
                    value={selectedPeriodicity}
                />

                {periodicityCopy}
            </div>
        );
    }

    getDayClassName(day, selectedValue, isAmountValid) {
        const customClass = classNames('ra-contribution-periodicity__day', {
            ['ra-contribution-periodicity__day--selected']: selectedValue === day,
            ['ra-contribution-periodicity__day--disabled']: !isAmountValid,
        });

        return customClass;
    }

    buildCustomCalendar() {
        const { amount, onDayClick, selectedDay, disabled } = this.props;
        const isAmountValid = amount >= 1;
        const handleDayClick = isAmountValid ? onDayClick : () => {};
        const calendarClass = classNames('ra-contribution-periodicity__calendar', {
            'ra-contribution-periodicity__calendar--disabled': disabled,
        });
        const days = times(FULL_MONTH_DAYS, index => {
            const day = index + 1;
            const dayClassName = this.getDayClassName(day, selectedDay, isAmountValid);

            return (
                <div key={day} data-id={day} onClick={handleDayClick} className={dayClassName}>
                    {day}
                </div>
            );
        });

        return (
            <div className={calendarClass}>
                <label className="ra-contribution-periodicity__calendar-label">
                    <FormattedText value="raContributionPeriodicity-monthCalendar" />
                </label>
                {days}
            </div>
        );
    }

    getMonthlyCalendar() {
        let monthlyCalendar;

        if (this.props.selectedPeriodicity === CONTRIBUTION_PERIOD_MONTHLY) {
            monthlyCalendar = this.buildCustomCalendar();
        }

        return monthlyCalendar;
    }

    render() {
        const {
            amount,
            errorMessage,
            errorState,
            hideFocusZero,
            keepZeroAndEmpty,
            onRecurringContributionChange,
            selectedPeriodicity,
            disabled,
        } = this.props;
        const periodicitySelect = this.buildPeriodicitySelect();
        const monthlyCalendar = this.getMonthlyCalendar();
        const max =
            selectedPeriodicity === CONTRIBUTION_PERIOD_PUNCTUAL
                ? MAXIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT
                : MAXIMUM_PERIODIC_CONTRIBUTION;

        return (
            <div className="ra-contribution-periodicity">
                <div className="ra-contribution-periodicity__amount-input">
                    <AmountInput
                        amount={amount}
                        callback={onRecurringContributionChange}
                        error={errorState}
                        errorMsg={errorMessage}
                        fluid={true}
                        hideFocusZero={hideFocusZero}
                        keepZeroAndEmpty={keepZeroAndEmpty}
                        label={formatText('raContributionPeriodicity-contributionAmount')}
                        language={getLanguage()}
                        max={max}
                        showBlurZero={false}
                        disabled={disabled}
                    />
                    <span className="ra-contribution-periodicity__amount-input-symbol">{EURO_SYMBOL}</span>
                </div>
                {periodicitySelect}
                {monthlyCalendar}
            </div>
        );
    }
}

RAContributionPeriodicity.defaultProps = {
    allowPunctual: false,
    disableSelect: false,
};

RAContributionPeriodicity.propTypes = {
    allowPunctual: PropTypes.bool,
    amount: PropTypes.number,
    disableSelect: PropTypes.bool,
    errorMessage: PropTypes.string,
    errorState: PropTypes.bool,
    hideFocusZero: PropTypes.bool,
    keepZeroAndEmpty: PropTypes.bool,
    onDayClick: PropTypes.func.isRequired,
    onPeriodicityChange: PropTypes.func.isRequired,
    onRecurringContributionChange: PropTypes.func.isRequired,
    selectedDay: PropTypes.string,
    selectedPeriodicity: PropTypes.number,
};

module.exports = RAContributionPeriodicity;
